export const RESCHEDULED_HOUR = 'RESCHEDULED_HOUR';
export const RESCHEDULED_DATE_STAGE = 'RESCHEDULED_DATE_STAGE';
export const RESCHEDULED_ARTIST = 'RESCHEDULED_ARTIST';
export const NEW_PERFORMANCE = 'NEW_PERFORMANCE';
export const DELETE_PERFORMANCE = 'DELETE_PERFORMANCE';

export const STATUS_CHANGED = 'STATUS_CHANGED';
export const COMMENT_CHANGE = 'COMMENT_CHANGE';

export function activityTypeToText(type) {
    if (type.includes('RESCHEDULED')) {
        return 'RESCHEDULED';
    }
    if (type.includes('COMMENT')) {
        return 'COMMENT';
    }
    if (type.includes('STATUS')) {
        return 'STATUS CHANGED';
    }
    switch (type) {
        case 'DELETE_PERFORMANCE':
            return 'PERFORMANCE REMOVED';
        case 'NEW_PERFORMANCE':
            return 'PERFORMANCE ADDED';
        default:
            return type;
    }
}



// WEBPACK FOOTER //
// ./src/constants/activity.js